const ROUNDING_DIGITS = 1;

export const ratingFromScore = (score) => {
  /**
   * Arguments:
   *  score (number): score from 0 to 100
   *
   * Returns:
   *  rating (number): rounded rating from 0 to 5. Returns undefined if score is undefined.
   */

  if (!score) {
    return undefined;
  }

  if (score < 0 || score > 100) {
    throw new Error('Score should be between 0 and 100.');
  }

  const roundingValue = 10 ** ROUNDING_DIGITS;

  return Math.round(score / 20 * roundingValue) / roundingValue;
};

export const scoreFromRating = (rating) => {
  /**
   * Arguments:
   *  rating (number): rating from 0 to 5
   *
   * Returns:
   *  score (number): score from 0 to 100. Returns undefined if score is undefined.
   */

  if (!rating) {
    return undefined;
  }

  if (rating < 0 || rating > 5) {
    throw new Error('Rating should be between 0 and 5.');
  }

  return rating * 20;
};
